import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { urlApi } from '../../../utils/apiConfig';


@Injectable()
export class RevendedoresService {
  constructor(private http: HttpClient) {
   }  

   public getRevendedores(): Observable<any>{
    return this.http.get(`${urlApi}/admin/revendedor/list`);
   }

   public setRevendedor(objectData: any): Observable<any>{
    return this.http.post(`${urlApi}/admin/revendedor/create`,objectData)
   }
}
